import { render } from "./ExclamationSvg.vue?vue&type=template&id=8c41bc06"
import script from "./ExclamationSvg.vue?vue&type=script&lang=js"
export * from "./ExclamationSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__